import { isPwaEnabled } from '@/api/config'

/* chromium fires beforeinstallprompt once, whenever it decides the app is
 * installable, so the event is kept in a module store main.tsx arms before the
 * first render and a real tap replays later. */
export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

let deferred: BeforeInstallPromptEvent | null = null
const listeners = new Set<() => void>()

function notify() {
  for (const listener of listeners) listener()
}

export function captureInstallPrompt(): void {
  if (typeof window === 'undefined') return
  window.addEventListener('beforeinstallprompt', event => {
    /* with PWA_ENABLED off we must not preventDefault: swallowing the event
     * would kill chromium's own install prompt without offering ours. */
    if (!isPwaEnabled()) return
    event.preventDefault()
    deferred = event as BeforeInstallPromptEvent
    notify()
  })
  window.addEventListener('appinstalled', () => {
    deferred = null
    notify()
  })
}

export function subscribeInstallPrompt(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getInstallPrompt(): BeforeInstallPromptEvent | null {
  return deferred
}

export function clearInstallPrompt(): void {
  deferred = null
  notify()
}
